import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import type { RootState } from '../../../../../../store';

export default function useTreatmentPlanV3FamilyPageState() {
  const { treatmentPlanId } = useParams<'treatmentPlanId'>();
  // Until this plan's fetch starts, the store still holds the previously viewed plan's family.
  const isCurrentPlan = useSelector(
    (state: RootState) => state.treatmentPlanV3.familyPageTreatmentPlanId === treatmentPlanId,
  );
  const hasLoaded =
    useSelector((state: RootState) => state.treatmentPlanV3.familyPage !== null) && isCurrentPlan;
  const hasLoadError =
    useSelector((state: RootState) => state.treatmentPlanV3.familyPageError != null) &&
    isCurrentPlan;
  const familyPageLoading = useSelector(
    (state: RootState) => state.treatmentPlanV3.familyPageLoading,
  );

  return {
    isLoading: familyPageLoading || (!hasLoaded && !hasLoadError),
    hasLoaded,
    hasLoadError,
  };
}
